// Final day — the policy expires at midnight.

import type { EmailData } from "../../types";
import { b, esc, p } from "../../layouts/chrome";
import { NO_PAYMENT, pricedEmailHtml } from "../../layouts/priced";
import { brand } from "../brand";

export const subject = (_data: EmailData) => `Final notice: your ${brand.name} policy expires at midnight`;

export const html = (data: EmailData) =>
  pricedEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    quotes: data.quotes ?? [],
    payment: data.payment ?? NO_PAYMENT,
    policyRef: data.policyRef,
    versionRef: data.versionRef,
    bodyHtml: p(
      `This is your final notice from ${brand.name}. Your insurance policy for your company ${b(`'${esc(data.companyName)}'`)} will ${b("expire at midnight")}. Renew today to keep your cover active and avoid any gaps.`,
    ),
  });
